import * as React from 'react';
import styles from './index.less';
import Exhibits from './Exhibits';
import Themes from './Themes';
import Contracts from './Contracts';
import Setting from './Setting';
import { history, useParams } from 'umi';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import {
  OnChange_ShowPage_Action,
  OnMount_Page_Action,
  OnUnmount_Page_Action,
} from '@/models/nodeManagerPage';
import { ConnectState, NodeManagerModelState } from '@/models/connect';
import * as AHooks from 'ahooks';
import FLoadingTip from '@/components/FLoadingTip';
// import { Helmet } from 'react-helmet';
import useUrlState from '@/hooks/useUrlState';
import Income from './Income';
import Transaction from './Transaction';
import FLeftSiderLayout from '@/layouts/FLeftSiderLayout';
import Sider from './Sider';
import { FI18n, FUtil } from '@freelog/tools-lib';

interface NodeManagerProps {
  dispatch: Dispatch;
  nodeManagerPage: NodeManagerModelState;
}

function NodeManager({ dispatch, nodeManagerPage }: NodeManagerProps) {
  const params = useParams();
  const id = params.id ?? '';
  const [{ showPage }] = useUrlState<{ showPage: 'exhibit' | 'theme' | 'contract' | 'setting' }>();

  AHooks.useMount(() => {
    dispatch<OnMount_Page_Action>({
      type: 'nodeManagerPage/onMount_Page',
      payload: {
        nodeID: Number(id),
        showPage: showPage,
      },
    });
  });

  React.useEffect(() => {
    dispatch<OnChange_ShowPage_Action>({
      type: 'nodeManagerPage/onChange_ShowPage',
      payload: {
        value: showPage,
      },
    });
  }, [showPage]);

  AHooks.useAsyncEffect(async () => {
    await dispatch<OnChange_ShowPage_Action>({
      type: 'nodeManagerPage/onChange_ShowPage',
      payload: {
        value: '',
      },
    });
    await dispatch<OnMount_Page_Action>({
      type: 'nodeManagerPage/onMount_Page',
      payload: {
        nodeID: Number(id),
        showPage: showPage,
      },
    });
  }, [id]);

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'nodeManagerPage/onUnmount_Page',
    });
  });

  if (nodeManagerPage.nodeInfoState === 'loading') {
    return <FLoadingTip height={'calc(100vh - 70px)'} />;
  }

  const showThemeReminderBanner =
    !nodeManagerPage.nodeThemeId && nodeManagerPage.nodeInfoState === 'loaded';

  return (
    <FLeftSiderLayout
      sider={<Sider />}
      type='empty'
      banner={
        showThemeReminderBanner ? (
          <div className={styles.themeReminderBanner}>
            <span className={styles.themeReminderText}>
              {/* 您还没有设置主题，节点将无法访问 */
              FI18n.i18nNext.t('nodemgnt_alert_notheme')
              }
            </span>
            <span
              className={styles.themeReminderBtn}
              onClick={() => {
                if (nodeManagerPage.showPage !== 'theme') {
                  history.push(
                    FUtil.LinkTo.nodeManagement({
                      nodeID: Number(id),
                      showPage: 'theme',
                    }),
                  );
                }
              }}
            >
              {/* 立即设置 */
              FI18n.i18nNext.t('nodemgnt_alert_notheme_btn_chooseatheme ')
              }
            </span>
          </div>
        ) : null
      }
    >
      <>
        {nodeManagerPage.showPage === 'exhibit' && <Exhibits />}
        {nodeManagerPage.showPage === 'theme' && <Themes />}
        {nodeManagerPage.showPage === 'contract' && <Contracts />}
        {nodeManagerPage.showPage === 'setting' && <Setting />}
        {nodeManagerPage.showPage === 'income' && <Income />}
        {nodeManagerPage.showPage === 'transaction' && <Transaction />}
      </>
    </FLeftSiderLayout>
  );
}

export default connect(({ nodeManagerPage, nodes }: ConnectState) => ({
  nodeManagerPage,
  nodes,
}))(NodeManager);
